import {View, Text, Image} from 'react-native';
import React from 'react';
import {Images} from '../../../../constants/Images';

interface INotFound {
  title: string;
  description?: string;
}

const NotEquipament = ({title, description}: INotFound) => {
  return (
    <View
      style={{
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
      }}>
      <View
        style={{
          flexDirection: 'row',
          alignItems: 'center',
        }}>
        <Image source={Images.equipamentIcon} />
        <Image
          source={Images.warningB}
          style={{
            position: 'absolute',
            left: 40,
          }}
        />
      </View>
      <Text
        style={{
          fontSize: 22,
          fontFamily: 'TCCC-UnityText Bold',
          lineHeight: 26,
          color: 'black',
          marginTop: 20,
          maxWidth: 250,
          textAlign: 'center',
        }}>
        {title}
      </Text>
      <Text
        style={{
          fontSize: 16,
          fontWeight: '400',
          lineHeight: 20,
          color: 'gray',
          maxWidth: 250,
          textAlign: 'center',
          marginTop: 10,
        }}>
        {description}
      </Text>
    </View>
  );
};

export default NotEquipament;
